module.exports = __webpack_public_path__ + "img/home-grouped-cars.c1291ea8.jpg";